export const getStatusVariant = (status) => {
    const variants = {
        confirmed: "success",
        failed: "error",
        awaiting_tutor_confirmations: "warning",
        cancelled: "error",
        pending: "warning",
        scheduled: "primary",
        ongoing: "secondary",
        completed: "success",
        no_show: "error",
        default: "default"
    };
    return variants[status] || variants.default;
};
